import * as React from "react";
import { useState } from "react";
import { Button } from "components/ui/button";
import { CloudSdkRive, type CloudSdkRiveInputs } from "./index";

export function IntegrateSection() {
  const [cloudSdkInputs, setCloudSdkInputs] =
    useState<CloudSdkRiveInputs | null>(null);

  const setHoverInput = (value: boolean) => {
    const boolInput = cloudSdkInputs?.getInput("isHover");
    if (boolInput) boolInput.value = value;
  };

  const handleMouseEnter = () => setHoverInput(true);
  const handleMouseLeave = () => setHoverInput(false);
  const handleRiveMouseLeave = () => setHoverInput(true);

  return (
    <section
      id="integrate"
      className="relative mx-auto w-full px-4 py-24 lg:px-6 xl:max-w-7xl"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div>
        <div className="mb-4">
          <h2 className="mb-4 text-3xl font-bold">Integrate into Brev</h2>
        </div>
        <div className="grid h-[400px] gap-8 md:grid-cols-1 lg:grid-cols-2">
          <div className="flex flex-col justify-center">
            <h3 className="mb-4 text-2xl font-bold">Cloud SDK</h3>
            <p className="text-muted-foreground mb-6">
              The Cloud SDK is your adapter, now wiring your cloud directly into
              Brev. You build the integration, we bring the demand.
            </p>
            <div>
              <Button variant="outline" asChild>
                <a
                  href="https://github.com/brevdev/cloud"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Documentation
                </a>
              </Button>
            </div>
          </div>
          <div
            className="flex flex-col border-r border-l border-zinc-800 py-4"
            onMouseLeave={handleRiveMouseLeave}
          >
            <CloudSdkRive
              scale={1.2}
              className="h-full w-full"
              onLoad={setCloudSdkInputs}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
